import { NotificationSubjectType } from 'types'
import Styles from '../../NotificationItem.module.scss'
import { InformalFeedbackRequestNotification } from '../../types'

import { Approved, Rejected, Feedback, Dismissed, Approval } from 'blaze-ui/icons/20'

export const iconForNotification = (notification: InformalFeedbackRequestNotification) => {
  if (
    [
      NotificationSubjectType.InformalFeedbackReviewsCreated,
      NotificationSubjectType.DesignInformalFeedbackReviewsCreated,
    ].includes(notification.subject.subject_type)
  ) {
    return (
      <span role="img" title="Approval Icon" className={Styles.icon}>
        <Approval size={20} />
      </span>
    )
  }

  if (
    [
      NotificationSubjectType.DesignInformalFeedbackReviewDismissed,
      NotificationSubjectType.InformalFeedbackReviewDismissed,
    ].includes(notification.subject.subject_type)
  ) {
    return (
      <span role="img" title="Dismissed Icon" className={Styles.icon}>
        <Dismissed size={20} />
      </span>
    )
  }

  const type = notification.subject.submit_type

  switch (type) {
    case 'feedback':
      return (
        <span role="img" title="Feedback Icon" className={Styles.icon}>
          <Feedback size={20} />
        </span>
      )
    case 'reject':
      return (
        <span role="img" title="Rejected Icon" className={Styles.icon}>
          <Rejected size={20} />
        </span>
      )
    case 'dismissed':
      return (
        <span role="img" title="Dismissed Icon" className={Styles.icon}>
          <Dismissed size={20} />
        </span>
      )
    case 'approve':
      return (
        <span role="img" title="Approved Icon" className={Styles.icon}>
          <Approved size={20} />
        </span>
      )
    default:
      return (
        <span role="img" title="Approval Icon" className={Styles.icon}>
          <Approval size={20} />
        </span>
      )
  }
}

export const titleForDeprecatedType = (subjectType: string) => {
  switch (subjectType) {
    case NotificationSubjectType.ReadReceiptRequest:
      return 'has requested you to mark this file as read'
    case NotificationSubjectType.ReadReceiptReminderSent:
      return 'reminded you to mark this file as read'
    case NotificationSubjectType.ReadReceiptMarkedRead:
      return 'marked as read'
    case NotificationSubjectType.ReadReceiptClosed:
      return 'has ended the review request'
    case NotificationSubjectType.SuggestionReviewCreated:
      return 'suggested changes'
    case NotificationSubjectType.SuggestionReviewReminder:
      return 'reminded you to review this file'
    case NotificationSubjectType.SuggestionReviewRejected:
      return 'requested some changes on your suggestions'
    case NotificationSubjectType.SuggestionReviewApproved:
      return 'approved your suggestions'
    case NotificationSubjectType.SuggestionReviewCancelled:
      return 'skipped reviewing your suggestions'
    case NotificationSubjectType.ApprovalRequestedAgain:
      return 'asked you to review this file again'
    case NotificationSubjectType.ApprovalReminded:
      return 'reminded you to review this file'
    case NotificationSubjectType.ApprovalRejected:
      return 'requested changes in your request'
    case NotificationSubjectType.ApprovalApproved:
      return 'has approved'
    case NotificationSubjectType.ApprovalCancelled:
      return 'has ended the review request'
    case NotificationSubjectType.ApprovalRequested:
    default:
      return 'asked you to review this file'
  }
}
